import React, { Component } from "react";
import { connect } from "react-redux";
import { saveTree, deleteTree } from "Thunks";
import { setCurrentTreeId } from "Actions";

import CategoryComponent from "./CategoryComponent";
import { setOpenDeleteConfirm, setFilterNotIn } from "Actions";

class Category extends Component {
  render() {
    return <CategoryComponent {...this.props} />;
  }
}

// Connected Component
const mapStateToProps = (state, ownProps) => ({
  //fetching: state.trees.fetching,
  //lng: state.params.lng
  saving: state.trees.saving,
  currentTreeId: state.trees.currentTreeId
});

const mapDispatchToProps = dispatch => ({
  saveTree: params => dispatch(saveTree(params)),
  deleteTree: params => dispatch(deleteTree(params)),
  setCurrentTreeId: id => dispatch(setCurrentTreeId(id)),
  setFilterNotIn: ids => dispatch(setFilterNotIn(ids)),
  setOpenDeleteConfirm: visible => dispatch(setOpenDeleteConfirm(visible))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Category);



// WEBPACK FOOTER //
// ./src/components/CategoriesList/Category/index.js